import React from 'react';

export function Skeleton({ width = '100%', height = 12, radius = 4, className = '' }) {
  return (
    <span
      className={`inline-block align-middle ${className}`}
      style={{
        width,
        height,
        borderRadius: radius,
        background: 'linear-gradient(90deg, var(--bg-s1) 0%, var(--bg-s2) 50%, var(--bg-s1) 100%)',
        backgroundSize: '200% 100%',
        animation: 'skeleton-shimmer 1.6s ease-in-out infinite',
      }}
    />
  );
}

export function SkeletonRow({ count = 4 }) {
  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} height={12} />
      ))}
    </div>
  );
}

export default Skeleton;
